import { render, staticRenderFns } from "./COM_Header.vue?vue&type=template&id=ef437e8a&scoped=true&"
import script from "./COM_Header.vue?vue&type=script&lang=js&"
export * from "./COM_Header.vue?vue&type=script&lang=js&"
import style0 from "./COM_Header.vue?vue&type=style&index=0&id=ef437e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef437e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef437e8a')) {
      api.createRecord('ef437e8a', component.options)
    } else {
      api.reload('ef437e8a', component.options)
    }
    module.hot.accept("./COM_Header.vue?vue&type=template&id=ef437e8a&scoped=true&", function () {
      api.rerender('ef437e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/COM_Header.vue"
export default component.exports